import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import NewVideoModal from "./newVideoModal.js";
import { ButtonGroup } from "baseui/button-group";
import { Button } from "baseui/button";
import { Card, StyledBody } from "baseui/card";
import { Tag, VARIANT } from "baseui/tag";

const EmployeeTraining = () => {
  const location = useLocation();
  const { roleId } = location.state || {}; // Safely access roleId from state

  useEffect(() => {
    console.log("location", location); // Log the entire location object
    console.log("roleId", roleId); // Logs the roleId passed from NavBar
  }, [roleId, location]);

  const [isOpen, setIsOpen] = useState(false);
  const [editObj, setEditObj] = useState({});

  // State to hold the trainings data
  const [trainings, setTrainings] = useState([]);
  const [loading, setLoading] = useState(true); // To track the loading state

  // Fetch trainings from the backend
  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const fetchTrainings = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/list/trainings`);
        setTrainings(response.data.trainings); // Save the trainings data to state
        setLoading(false); // Set loading to false after data is fetched
      } catch (error) {
        console.error("Error fetching trainings: ", error);
        setLoading(false); // Set loading to false in case of an error
      }
    };

    fetchTrainings();
  }, []);

  // https://youtu.be/qR8zeNPK_4g?si=1dquIt1ANF3DJMog
  //https://www.youtube.com/watch?v=qR8zeNPK_4g

  // console.log("trainings", trainings);

  //STYLE SETTINGS FOR BASEUI BUTTONS, TAGS
  const tagStyles = {
    backgroundColor: "#bad8eb",
    fontSize: "1rem",
    color: "black",
    paddingTop: "1.5rem", // Using full property instead of shorthand
    paddingBottom: "1.5rem", // Ensure top and bottom are defined separately
    paddingLeft: "1.5rem", // Separate left and right if needed
    paddingRight: "1.5rem",
    marginTop: "0",
  };

  const buttonStyles = ({ $theme }) => ({
    paddingTop: ".5rem", // Full properties for consistency
    paddingBottom: ".5rem",
    paddingLeft: ".5rem",
    paddingRight: ".5rem",
    backgroundColor: "#e1dbd1",
    cursor: "pointer",
    marginRight: ".5rem",
    color: "black",
    ":hover": {
      backgroundColor: "#d6cec2", // Darkened grey on hover
    },
  });

  const YouTubeThumbnail = ({ videoUrl }) => {
    let videoId;

    // Check if URL contains '?v=' (query parameter style)
    if (videoUrl.includes("v=")) {
      videoId = videoUrl.split("v=")[1].split("&")[0]; // Extract the video ID and handle any additional query parameters
    }
    // Check if the URL is in a format with the video ID at the end (like https://youtu.be/xxxxxx)
    else if (videoUrl.includes("youtu.be/")) {
      videoId = videoUrl.split("youtu.be/")[1].split("?")[0]; // Extract the video ID and remove query parameters
    }
    // Handle full YouTube URL without query params (like https://www.youtube.com/watch/xxxxxx)
    else if (videoUrl.includes("/watch/")) {
      videoId = videoUrl.split("/watch/")[1].split("?")[0];
    }

    // Construct the thumbnail URL using the extracted video ID
    const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

    return (
      <div>
        <a href={videoUrl} target="_blank" rel="noopener noreferrer">
          <img
            src={thumbnailUrl}
            alt="YouTube Thumbnail"
            style={{ width: "100%" }}
          />
        </a>
      </div>
    );
  };

  return (
    <div style={{ paddingBottom: "3rem" }}>
      <h1>Employee Training</h1>
      {loading ? (
        <p>Loading trainings...</p>
      ) : (
        <>
          {roleId === 2 && (
            <ButtonGroup>
              <Button
                style={{
                  marginLeft: "2rem",
                  backgroundColor: "#bad8eb",
                  border: "1px solid black",
                }}
                onClick={() => setIsOpen(true)}
              >
                Add a New Video
              </Button>
            </ButtonGroup>
          )}
          <div
            style={{
              // border: "2px solid blue",
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
            }}
          >
            {trainings.map((training) => (
              <Card
                key={training.id}
                overrides={{
                  Root: {
                    style: {
                      backgroundColor: "#F5F3F0",
                      maxWidth: "25rem",
                      height: "min-content",
                    },
                  },
                }}
              >
                <StyledBody>
                  <YouTubeThumbnail
                    // videoUrl={`https://www.youtube.com/watch?v=${training.url}`}
                    videoUrl={training.url}
                  />

                  <h1>{training.name}</h1>
                  <p style={{ color: "grey" }}> {training.description}</p>
                  <h4>Tags:</h4>
                  {training.tags
                    .split(",") // Assuming tags are joined by ", "
                    .map((tag, index) => (
                      <Tag
                        closeable={false}
                        key={index}
                        overrides={{
                          Root: {
                            style: tagStyles,
                          },
                        }}
                        variant={VARIANT.solid}
                      >
                        {tag}
                      </Tag>
                    ))}
                  <br />
                  {/* EDIT TRAINING BUTTON */}

                  {roleId === 2 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "1rem",
                      }}
                    >
                      <Button
                        onClick={() => {
                          alert("you're assigning a video");
                        }}
                        overrides={{
                          BaseButton: {
                            style: buttonStyles,
                          },
                        }}
                      >
                        Assign Video
                      </Button>
                      <Button
                        onClick={() => {
                          setIsOpen(true);
                          setEditObj(training);
                        }}
                        overrides={{
                          BaseButton: {
                            style: buttonStyles,
                          },
                        }}
                      >
                        Edit Video
                      </Button>
                    </div>
                  )}
                  {/* )} */}
                </StyledBody>
              </Card>
            ))}
          </div>
        </>
      )}

      <NewVideoModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        editObj={editObj}
        setEditObj={setEditObj}
      />

      {/* Render the trainings data */}
    </div>
  );
};

export default EmployeeTraining;
